import { useQuery } from "@tanstack/react-query";
import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { useApi } from "../../shared/api/index";

export const useFetchVenue = () => {
  const { fetchData } = useApi();
  const { organizationId, sport, dataId } = useParams();

  return useQuery({
    queryKey: ["venues", sport, organizationId, dataId],
    queryFn: async () => {
      const result = await fetchData({
        url: `${sport}/o/${organizationId}/venues/${dataId}`,
      });
      return result?.data?.[0];
    },
    enabled: !!dataId,
  });
};

export const useFetchVenueById = (id) => {
  const { fetchData } = useApi();
  const { organizationId, sport } = useParams();

  return useQuery({
    queryKey: ["venues", sport, organizationId, id],
    queryFn: async () => {
      const result = await fetchData({
        url: `${sport}/o/${organizationId}/venues/${id}`,
      });
      return result?.data?.[0];
    },
    enabled: false,
  });
};
const defaultParams = { sortBy: "nameLocal" }

export const useFetchVenues = (params = {}, enabled) => {
  const { fetchData } = useApi();
  const { organizationId, sport } = useParams();
  let URL = `${sport}/o/${organizationId}/venues`;
  if (!isEmpty(params)) {
    URL += `?${new URLSearchParams(params)?.toString()}`;
  }

  return useQuery({
    queryKey: ["venues", sport, organizationId, JSON.stringify(params)],
    queryFn: async () => {
      const result = await fetchData({
        url: URL,
      });
      return result?.data || [];
    },
    enabled: !!enabled,
  });
};
